(function($) {

	'use strict';

	var init = function() {
        
        if($('.fp-hero__video').length > 0) {

            var $video = $('.fp-hero__video');
            
            initVideo($video);

		    videoTrigger($video);
        }   

    };

    var initVideo = function($video) {

        $(window).resize(function() {

            if($(window).width() >= 768) {
                $video.append('<source src="' + $video.data('video-desktop') + '" type="video/mp4">');
            } else {
                $video.append('<source src="' + $video.data('video-mobile') + '" type="video/mp4">');
            }
            $video.prop('preload', 'auto');

            $video.on('loadstart', function() {
                $('.fp-hero__loader').addClass('active');
                $video.addClass('active');
                $video.trigger('play');
            });

        }).resize();

    }
    
    var videoTrigger = function($video) {

        $(window).scroll(function() {

            var windowScroll = $(window).scrollTop();

            var videoOffset = $video.offset().top;
            
            var videoHeight = $video.height();

            var windowHeight = $(window).height();
            
			if((windowScroll >= windowHeight)) {
                $video.trigger('pause');
			} else {
                $video.trigger('play');
            }

        });

        $(window).on('beforeunload', function() { 
            $video.fadeOut('slow');
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);